import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function normalize(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    taskKey:x.taskKey||null,
    completedAt:Number.isFinite(x.completedAt)?x.completedAt:null,
    evidenceFingerprint:x.evidenceFingerprint||null,
    result:x.result||'UNKNOWN',
    reopened:x.reopened===true
  });
}
function sameEvidence(a,b){
  const x=normalize(a),y=normalize(b);
  return !!x.evidenceFingerprint && x.evidenceFingerprint===y.evidenceFingerprint;
}
function shouldReopen(previous,current){
  const p=normalize(previous),c=normalize(current);
  if(!p.completedAt) return true;
  if(p.reopened) return true;
  if(!sameEvidence(p,c)) return true;
  return false;
}
function merge(previous,current){
  const p=normalize(previous),c=normalize(current);
  const reopen=shouldReopen(p,c);
  return Object.freeze({
    symbol:c.symbol||p.symbol,
    taskKey:c.taskKey||p.taskKey,
    state:reopen?'OPEN':'COMPLETED',
    previousResult:p.result,
    currentResult:c.result,
    evidenceChanged:!sameEvidence(p,c),
    tradeSignal:false
  });
}
function dedupeHistory(rows){
  const list=Array.isArray(rows)?rows:[];
  const map=new Map();
  for(const r0 of list){
    const r=normalize(r0);
    const k=`${r.symbol||'UNKNOWN'}|${r.taskKey||'UNKNOWN'}`;
    const old=map.get(k);
    if(!old || (r.completedAt||0)>(old.completedAt||0)) map.set(k,r);
  }
  return Object.freeze([...map.values()]);
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const prev={symbol:'AAA',taskKey:'VERIFY',completedAt:100,evidenceFingerprint:'abc',result:'CLEAR'};
  const same={symbol:'AAA',taskKey:'VERIFY',completedAt:200,evidenceFingerprint:'abc',result:'CLEAR'};
  const changed={symbol:'AAA',taskKey:'VERIFY',completedAt:200,evidenceFingerprint:'xyz',result:'REVIEW'};
  ok('same evidence does not reopen completed task',shouldReopen(prev,same)===false);
  ok('changed evidence reopens task',shouldReopen(prev,changed)===true);
  ok('missing completion reopens task',shouldReopen({...prev,completedAt:null},same)===true);
  ok('explicit reopen reopens task',shouldReopen({...prev,reopened:true},same)===true);
  ok('merge preserves completed state on same evidence',merge(prev,same).state==='COMPLETED');
  ok('merge opens changed evidence',merge(prev,changed).state==='OPEN');
  ok('merge exposes evidence change',merge(prev,changed).evidenceChanged===true);
  ok('merge remains non-trading',merge(prev,changed).tradeSignal===false);
  const d=dedupeHistory([prev,{...prev,completedAt:300,result:'UPDATED'}]);
  ok('history dedupe keeps one record',d.length===1);
  ok('history dedupe keeps latest record',d[0].completedAt===300);
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,normalize,sameEvidence,shouldReopen,merge,dedupeHistory,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestResearchCompletionMemoryEngine=Object.freeze(API);
})(engineContext);
